import {
    ILoadDynamicContentState,
    loadDynamicContentAT,
} from "./LoadDynamicContentModel";

export function loadDynamicContentReducer(
    state = {} as ILoadDynamicContentState,
    action
): ILoadDynamicContentState {
    switch (action.type) {
        case loadDynamicContentAT.hasCustomerConfig:
            return { ...state, config: action.config };

        case loadDynamicContentAT.hasCustomerInfo:
            return { ...state, info: action.info };

        default:
            return state;
    }
}
